<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <!-- Download de relatório -->
        <div title="Clique para baixar o aplicativo" class="m-icone direita">
          <a href="https://drive.google.com/file/d/1wuaCaIZalghqvqPo3csqEiQH437qFZee/view?usp=sharing" target="_blank">
            <div class="icone-download-apk" style="transform: scale(1.5)"></div>
          </a>
        </div>
        <h2>Monitor de dispositivos</h2>
      </div>
    </div>

    <div class="margem">
      <div class="margem container bloco">
        <!-- Filtros -->
        <div class="filtros">
          <div class="filtro-busca">
            <input type="text" v-model="searchTerm" placeholder="Buscar por código, marca ou modelo..." @keyup.enter="getData(1)" />
            <button @click="getData(1)">Buscar</button>
          </div>
        </div>

        <table class="tabela">
          <thead>
            <tr>
              <th>Id</th>
              <th>Código do dispositivo</th>
              <th>Marca</th>
              <th>Modelo</th>
              <th>Último registro</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="element in dats" :key="element.id" v-on:click="pushTo(element)">
              <td>{{ element.id }}</td>
              <td>{{ element.deviceCode }}</td>
              <td>{{ element.brand }}</td>
              <td>{{ element.model }}</td>
              <td>{{ formatarData(element.lastBatteryAt) }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Paginação -->
        <div v-if="pagination.lastPage > 1" class="paginacao">
          <button @click="getData(1)" :disabled="pagination.currentPage <= 1">Primeira</button>
          <button @click="getData(pagination.currentPage - 1)" :disabled="pagination.currentPage <= 1">Anterior</button>
          <span>Página {{ pagination.currentPage }} de {{ pagination.lastPage }}</span>
          <button @click="getData(pagination.currentPage + 1)" :disabled="pagination.currentPage >= pagination.lastPage">Próxima</button>
          <button @click="getData(pagination.lastPage)" :disabled="pagination.currentPage >= pagination.lastPage">Última</button>
        </div>

        <div v-if="dats.length > 0" class="info-total">Exibindo {{ dats.length }} de {{ pagination.total }} dispositivos</div>
      </div>

      <div v-if="!isDataLoaded" class="loading">
        <div></div>
      </div>
    </div>
  </section>
</template>

<script>
import DeviceDataSource from "@/data/datasource/DeviceDataSource";
import { RoutesName } from "@/router";
import { getDispositivoStorageKey } from "@/utils/dispositivo-storage";

const repo = new DeviceDataSource();

export default {
  data() {
    return {
      dats: [],
      isDataLoaded: false,
      searchTerm: "",
      pagination: {
        currentPage: 1,
        lastPage: 1,
        perPage: 10,
        total: 0,
      },
    };
  },
  methods: {
    getData: async function (page = 1) {
      this.isDataLoaded = false;

      try {
        const result = await repo.getDevices(page, this.pagination.perPage, this.searchTerm);
        this.dats = result.devices;
        this.pagination = result.pagination;
      } catch (error) {
        console.error("Erro ao buscar dispositivos:", error);
        this.dats = [];
      }

      this.isDataLoaded = true;
    },

    formatarData(valor) {
      if (!valor) return "—";
      const data = new Date(valor);
      if (Number.isNaN(data.getTime())) return "—";
      return data.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    /**
     * @param {DeviceModel} item
     */
    pushTo: function pushToNewPage(item) {
      // Salva apenas o ID para buscar detalhes na próxima página
      sessionStorage.setItem(getDispositivoStorageKey(), JSON.stringify({ id: item.id }));
      this.$router.push(RoutesName.painelDispositivo);
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.filtros {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.filtro-busca {
  display: flex;
  gap: 8px;
}

.filtro-busca input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 280px;
}

.filtro-busca button {
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.filtro-busca button:hover {
  background: #f3f4f6;
}

.paginacao {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px;
}

.paginacao button {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.paginacao button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.paginacao button:hover:not(:disabled) {
  background: #f3f4f6;
}

.info-total {
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  margin-top: 8px;
}
</style>
